import React from "react";

import Lamina26img1 from "../images/lamina26img1.png";
import Lamina26act2 from "../images/lamina26img2.png";
import Lamina26actividad from "../images/lamina26actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  purple: {
    color: theme.palette.purple.main,
    borderColor: theme.palette.purple.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
      },
    },
  },
  yellowIcon: {
    color: "#fff",
    width: 25,
    height: 25,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
  },
  actText: {
    display: "flex",
    marginBottom: 10,
  },
  actContent: {
    width: "calc(100% - 35px)",
    marginLeft: 10,
    minHeight: 25,
  },
}));

const Lamina26 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 26: ¿Qué hace el congreso?"
        meta={[
          {
            property: "og:title",
            content: "Lámina 26: ¿Qué hace el congreso?",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Elabora las leyes de acuerdo con los derechos y las responsabilidades de la ciudadanía.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="26" color="purple" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <Title title="¿Qué hace el congreso?" color="purple" size="md" />
          </Grid>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <img src={Lamina26img1} alt="Qué hace el congreso" />
          </Grid>
        </Grid>

        <p>
          Elabora las leyes de acuerdo con los derechos y las responsabilidades
          de la ciudadanía. Es el Poder Legislativo del país. Además, tiene el
          deber de representar a los ciudadanos y de fiscalizar a los
          funcionarios del Estado.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>Lee lo escrito en la pizarra.</strong>
        </p>
        <img src={Lamina26act2} alt="Actividad" />
        <p>Ahora completa las oraciones usando las palabras subrayadas.</p>
        <div className={classes.actText}>
          <div
            className={classes.yellowIcon}
            style={{ backgroundColor: "#00aeef" }}
          >
            1
          </div>
          <div className={classes.actContent}>
            Las congresistas y los congresistas intermedian entre las personas y
            las instituciones del Estado. Eso quiere decir que
            ______________________________ a la ciudadanía.
          </div>
        </div>
        <div className={classes.actText}>
          <div
            className={classes.yellowIcon}
            style={{ backgroundColor: "#6a2c91" }}
          >
            2
          </div>
          <div className={classes.actContent}>
            El Congreso vigila o controla al Poder Ejecutivo y a otras
            instituciones del Estado para asegurarse de que cumplan con sus
            funciones y con las leyes. Eso significa que los
            ______________________________.
          </div>
        </div>
        <div className={classes.actText}>
          <div
            className={classes.yellowIcon}
            style={{ backgroundColor: "#ec008c" }}
          >
            3
          </div>
          <div className={classes.actContent}>
            Una ______________________________ es un grupo de personas que
            tienen las mis- mas ideas sobre cómo gobernar un país. Puede
            participar en las elecciones.
          </div>
        </div>
        <div className={classes.actText}>
          <div
            className={classes.yellowIcon}
            style={{ backgroundColor: "#00a77e" }}
          >
            4
          </div>
          <div className={classes.actContent}>
            Las congresistas y los congresistas proponen, revisan y aprueban
            leyes para el beneficio de la totalidad de peruanas y peruanos. Eso
            quiere decir que ______________________________.
          </div>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>
            Observa las siguientes viñetas. En cada una hay dos opciones.
          </strong>{" "}
          En cada caso, marca con un aspa (X) la opción que expresa la forma
          correcta de ejercer las funciones del Congreso.
        </p>
        <img src={Lamina26actividad} alt="Actividad" />
        <p>
          Ahora identifica un problema que tiene tu localidad y propón una ley
          que pue- da ayudar a solucionarlo.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-26.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.purple }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 26: ¿Qué hace el congreso?'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="¿Quiénes nos gobiernan?"
        anteriorEnlace="/lamina-1-25"
        siguiente="¿Qué hace el poder judicial?"
        siguienteEnlace="/lamina-1-27"
      />
    </>
  );
};

export default Lamina26;
